import { Component, OnInit } from '@angular/core';
import { TopCedoleService } from 'src/app/core/services/tables/top-cedole.service';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { TopCedoleMemoria } from 'src/app/models/topCedoleMemoria';
import { Helpers } from 'src/app/models/Helpers/helpers';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import {animate, style, transition, trigger, state} from '@angular/animations';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-top-cedole-memoria-table',
  templateUrl: './top-cedole-memoria-table.component.html',
  styleUrls: ['./top-cedole-memoria-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class TopCedoleMemoriaTableComponent implements OnInit {

  TABLE_TITLE = 'Top Cedole Memoria';
  VIEW_ALL_PATH = '/menu/top-cedole-memoria';
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['Isin', 'Isin'],
    ['Nome', 'Nome'],
    ['Scadenza', 'Scadenza'],
    ['Demit', 'Emittente'],
    ['Dmercato', 'Mercato'],
    ['Dsott', 'Sottostante'],
    ['Totale', 'Totale'],
    ['Ask', 'Lettera'],
    ['Importo', 'Importo'],
    ['Nextdate', 'Next Date'],
    ['Datrigger', 'Buffer']
  ];

  tableInfoExists: boolean;

  records: TopCedoleMemoria[];
  dataStatus = new DataStatus();
  loader = new Loader();

  sortingFilter: string;
  sortingAscending: boolean;

  state = 'collapsed';

  constructor(
    private service: TopCedoleService,
    private infoService: InfoService,
    public dialogService: DialogService,
    private addToWatchlistManager: AddToWatchlistManagerService,
  ) { }

  ngOnInit(): void {
    this.tableInfoExists = this.infoService.isThereInfo(this.TABLE_TITLE);
  }


  private async getRecords() {
    this.dataStatus.resetStatus();
    this.loader.show();

    const result = await this.service.get(1, 10, this.sortingFilter, this.sortingAscending)
      .catch(error => {
        console.log('ERROR in TOP CEDOLE MEMORIA SECTION - GET', error);
        this.dataStatus
          .setStatus('failure')
          .setAlertMessage('Errore nel caricamento dei dati')
          .setAlertClasses(['cedlab-danger']);
        this.loader.hide();
      });
    if (!result) { return; }

    if (result.totalRecords > 0) {
      this.records = result.records;
      this.dataStatus.setStatus('success');
    } else {
      this.records = [];
      this.dataStatus
        .setStatus('info')
        .setAlertMessage('Nessun isin presente')
        .setAlertClasses(['cedlab-info']);
    }

    this.loader.hide();
  }

  public triggerSorting({ active, direction }) {

    this.sortingFilter = active;

    switch (direction) {
      case 'asc':
        this.sortingAscending = true;
        break;
      case 'desc':
        this.sortingAscending = false;
        break;
      default: this.sortingAscending = null;
    }

    this.getRecords().then();
  }


  public addIsinToWatchlist(isin: string): void {
    this.addToWatchlistManager.addToWatchlist(isin);
  }

  public localeCurrency = (currency: string) => Helpers.getCurrencyLocale(currency);
  public currencySymbol = (currency: string) => Helpers.getCurrencySymbol(currency);
  public openInfoDialog() {
    const tableInfo = this.infoService.getTableInfo(this.TABLE_TITLE);
    this.dialogService.openTableInfoDialog(tableInfo);
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (this.state === 'expanded') {
      this.getRecords().then();
    }
  }
}
